// frontend/src/components/book/atelier/store/coverPatch.js
//
// Traduit des champs du formulaire de couverture en modification du store.
// Le titre est une colonne a part, tout le reste vit dans cover_overrides ;
// couleur/teinte vides = pas de surcharge, style d'album vide = 'nu'. Seuls
// les champs MODIFIES sont ecrits : les surcharges que le panneau ne gere pas
// (cadrages, photos choisies sur la page) ne sont jamais touchees.
export const coverPatchFor = (fields) => {
  const patch = { overrides: {} };
  Object.entries(fields).forEach(([field, value]) => {
    if (field === 'title') patch.title = value;
    else if (field === 'coverColor' || field === 'tone') patch.overrides[field] = value || null;
    else if (field === 'albumStyle') patch.overrides[field] = value || 'nu';
    else patch.overrides[field] = value;
  });
  return patch;
};
